<template>
  <div class="vx-row" v-if="wallet">
    <vs-chip transparent color="primary" class="vx-col w-full font-sm">
      {{ $t('wallets.credit') }} {{ wallet.amount | toman }}
    </vs-chip>
  </div>
</template>

<script>
export default {
  name: 'Wallet',
  computed: {
    wallet() {
      return this.$store.state.AppActiveUser.wallet
    }
  },
  created() {
    this.$store.dispatch('wallet/fetchMyWallet')
  }
}
</script>
